import { render, staticRenderFns } from "./MakeQuestionMath.vue?vue&type=template&id=e7e89e7e&scoped=true&lang=pug&"
import script from "./MakeQuestionMath.vue?vue&type=script&lang=ts&"
export * from "./MakeQuestionMath.vue?vue&type=script&lang=ts&"
import style0 from "./MakeQuestionMath.vue?vue&type=style&index=0&id=e7e89e7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e89e7e",
  null
  
)

export default component.exports